// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as ApiUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as AllocationDashboardRepoConfig from "./AllocationDashboardRepoConfig.bs.js";

var filterAllocationCampaingsDummyUsecase1 = {
        "campaigns":[
          {
            "geo_region_id":1,
            "vehicle_id":2,
            "id":1,
            "campaign_status":"active",
            "effective_from":1698470518000.0,
            "filters":{
                "allocation_radius": {
                "auto":7000,
                "manual":4550
              },
                "dry_run":{
                "threshold":9089,
                "ratio":0.78
              },
              "maps_distance": {
                "manual":8500,
                "auto":950
              }
            },
            "creator_info": {
              "created_by":{
                "name": "test",
                "email_id": "test@abc.com"
              },
              "created_on": 1677066467000.0
            },
            "approver_info": {
              "approved_by":{
                "name": "test",
                "email_id": "test@abc.com"
              },
              "approved_on": 1677066467000.0
            }
          },
          
          {
            "geo_region_id":1,
            "vehicle_id":2,
            "name":"Holi Mandatory Campaign",
            "id":1,
            "campaign_status":"scheduled",
            "effective_from":1698470518000.0,
            "effective_till":1677757034000.0,
            "filters":{
                "allocation_radius": {
                "auto":7000,
                "manual":4550
              },
                "dry_run":{
                "threshold":9089,
                "ratio":0.78
              },
              "maps_distance": {
                "manual":8500,
                "auto":950
              }
            },
            "creator_info": {
              "created_by":{
                "name": "test",
                "email_id": "test@abc.com"
              },
              "created_on": 1677066467000.0
            },
            "approver_info": {
              "approved_by":{
                "name": "test",
                "email_id": "test@abc.com"
              },
              "approved_on": 1677066467000.0
            }
          },
          {
            "geo_region_id":1,
            "vehicle_id":2,
            "name":"Holi Mandatory Campaign",
            "id":1,
            "campaign_status":"scheduled",
            "effective_from":1698470518000.0,
            "effective_till":1677757034000.0,
            "filters":{
                "allocation_radius": {
                "auto":7000,
                "manual":4550
              },
                "dry_run":{
                "threshold":9089,
                "ratio":0.78
              },
              "maps_distance": {
                "manual":8500,
                "auto":950
              }
            },
            "creator_info": {
              "created_by":{
                "name": "test",
                "email_id": "test@abc.com"
              },
              "created_on": 1677066467000.0
            },
            "approver_info": {
              "approved_by":{
                "name": "test",
                "email_id": "test@abc.com"
              },
              "approved_on": 1677066467000.0
            }
          },
          {
            "geo_region_id":1,
            "vehicle_id":2,
            "name":"Holi Mandatory Campaign",
            "id":1,
            "campaign_status":"scheduled",
            "effective_from":1698470518000.0,
            "effective_till":1677757034000.0,
            "filters":{
                "allocation_radius": {
                "auto":7000,
                "manual":4550
              },
                "dry_run":{
                "threshold":9089,
                "ratio":0.78
              },
              "maps_distance": {
                "manual":8500,
                "auto":950
              }
            },
            "creator_info": {
              "created_by":{
                "name": "test",
                "email_id": "test@abc.com"
              },
              "created_on": 1677066467000.0
            },
            "approver_info": {
              "approved_by":{
                "name": "test",
                "email_id": "test@abc.com"
              },
              "approved_on": 1677066467000.0
            }
          },
          {
            "geo_region_id":1,
            "vehicle_id":2,
            "name":"Holi Mandatory Campaign",
            "id":1,
            "campaign_status":"scheduled",
            "effective_from":1698470518000.0,
            "effective_till":1677757034000.0,
            "filters":{
                "allocation_radius": {
                "auto":7000,
                "manual":4550
              },
                "dry_run":{
                "threshold":9089,
                "ratio":0.78
              },
              "maps_distance": {
                "manual":8500,
                "auto":950
              }
            },
            "creator_info": {
              "created_by":{
                "name": "test",
                "email_id": "test@abc.com"
              },
              "created_on": 1677066467000.0
            },
            "approver_info": {
              "approved_by":{
                "name": "test",
                "email_id": "test@abc.com"
              },
              "approved_on": 1677066467000.0
            }
          },{
            "geo_region_id":1,
            "vehicle_id":2,
            "name":"Holi Mandatory Campaign",
            "id":1,
            "campaign_status":"scheduled",
            "effective_from":1698470518000.0,
            "effective_till":1677757034000.0,
            "filters":{
                "allocation_radius": {
                "auto":7000,
                "manual":4550
              },
                "dry_run":{
                "threshold":9089,
                "ratio":0.78
              },
              "maps_distance": {
                "manual":8500,
                "auto":950
              }
            },
            "creator_info": {
              "created_by":{
                "name": "test",
                "email_id": "test@abc.com"
              },
              "created_on": 1677066467000.0
            },
            "approver_info": {
              "approved_by":{
                "name": "test",
                "email_id": "test@abc.com"
              },
              "approved_on": 1677066467000.0
            }
          },
          {
            "geo_region_id":1,
            "vehicle_id":2,
            "name":"Holi Mandatory Campaign",
            "id":1,
            "campaign_status":"pending",
            "effective_from":1698470518000.0,
            "effective_till":1677757034000.0,
            "filters":{
                "allocation_radius": {
                "auto":7540,
                "manual":4500
              },
                "dry_run":{
                "threshold":9089,
                "ratio":0.78
              },
              "maps_distance": {
                "manual":8500,
                "auto":950
              }
            },
            "creator_info": {
              "created_by":{
                "name": "test",
                "email_id": "test@abc.com"
              },
              "created_on": 1677066467000.0
            },
            "approver_info": {
              "approved_by":{
                "name": "test",
                "email_id": "test@abc.com"
              },
              "approved_on": 1677066467000.0
            }
          }
        ],
      };

var updateStatusSuccessfulResponse = {
      "campaign_id": "1234",
      "action": "approve"
    };

var userTypeDummyAdminAccessUsecase1 = {
    "access_level":"ADMIN_ACCESS"
  };

var zoneClusterPayloadUsecase1 = {
  "campaigns": [
    {
      "id": 112,
      "name": "test8",
      "geo_region_id": 3,
      "vehicle_id": 2,
      "zone_ids": [
        400,401,398,402,403,1,10,37
      ],
      "cluster_ids": null,
      "type": "Filter",
      "sub_type": "AllocationRadius",
      "priority": 1,
      "pending_priority": 1,
      "status": "Pending",
      "day_start_min": null,
      "day_start_hour": null,
      "day_end_min": null,
      "day_end_hour": null,
      "days_of_week": [
        "SUNDAY",
        "MONDAY",
        "TUESDAY",
        "WEDNESDAY",
        "THURSDAY",
        "FRIDAY",
        "SATURDAY"
      ],
      "effective_from": 1701539760000,
      "effective_till": null,
      "values": {
        "auto": 1000,
        "ratio": null,
        "manual": 1000,
        "threshold": null
      },
      "creation_info": {
        "actor": {
          "name": null,
          "email_id": "test@xyz.com"
        },
        "time": 1701241495749
      },
      "approval_info": null
    },
    {
      "id": 113,
      "name": "test11",
      "geo_region_id": 3,
      "vehicle_id": 2,
      "zone_ids": [
        400
      ],
      "cluster_ids": [
        317,306,368,297,303
      ],
      "type": "Filter",
      "sub_type": "AllocationRadius",
      "priority": 2,
      "pending_priority": 2,
      "status": "Pending",
      "day_start_min": null,
      "day_start_hour": null,
      "day_end_min": null,
      "day_end_hour": null,
      "days_of_week": [
        "SUNDAY",
        "MONDAY",
        "TUESDAY",
        "WEDNESDAY",
        "THURSDAY",
        "FRIDAY",
        "SATURDAY"
      ],
      "effective_from": 1701509760000,
      "effective_till": 1701509760000,
      "values": {
        "auto": 1000,
        "ratio": null,
        "manual": 1000,
        "threshold": null
      },
      "creation_info": {
        "actor": {
          "name": null,
          "email_id": "test@xyz.com"
        },
        "time": 1701242884214
      },
      "approval_info": null
    },
    {
      "id": 114,
      "name": "test12",
      "geo_region_id": 3,
      "vehicle_id": 2,
      "zone_ids": [
        401
      ],
      "cluster_ids": [
        317,306,368,297,303
      ],
      "type": "Filter",
      "sub_type": "DryRun",
      "priority": 3,
      "pending_priority": 3,
      "status": "Pending",
      "day_start_min": null,
      "day_start_hour": null,
      "day_end_min": null,
      "day_end_hour": null,
      "days_of_week": [
        "SUNDAY",
        "MONDAY",
        "TUESDAY",
        "WEDNESDAY",
        "THURSDAY",
        "FRIDAY",
        "SATURDAY"
      ],
      "effective_from": 1701539760000,
      "effective_till": 1701549760000,
      "values": {
        "auto": 20000,
        "ratio": 1.12,
        "manual": 5600,
        "threshold": 34500
      },
      "creation_info": {
        "actor": {
          "name": null,
          "email_id": "test@xyz.com"
        },
        "time": 1701242909954
      },
      "approval_info": null
    },
    {
      "id": 115,
      "name": "test2",
      "geo_region_id": 3,
      "vehicle_id": 2,
      "zone_ids": [
        398
      ],
      "cluster_ids": [
        297,303
      ],
      "type": "Filter",
      "sub_type": "DryRun",
      "priority": 4,
      "pending_priority": 4,
      "status": "Pending",
      "day_start_min": null,
      "day_start_hour": null,
      "day_end_min": null,
      "day_end_hour": null,
      "days_of_week": [
        "SUNDAY",
        "MONDAY",
        "TUESDAY",
        "WEDNESDAY",
        "THURSDAY",
        "FRIDAY"
      ],
      "effective_from": 1701539760000,
      "effective_till": null,
      "values": {
        "auto": 20000,
        "ratio": 1.12,
        "manual": 5600,
        "threshold": 34500
      },
      "creation_info": {
        "actor": {
          "name": null,
          "email_id": "test@xyz.com"
        },
        "time": 1701243522531
      },
      "approval_info": null
    },
    {
      "id": 116,
      "name": "test21",
      "geo_region_id": 3,
      "vehicle_id": 2,
      "zone_ids": [
        400,401,398,402,403
      ],
      "cluster_ids": null,
      "type": "Filter",
      "sub_type": "MapsDistance",
      "priority": 5,
      "pending_priority": 5,
      "status": "Pending",
      "day_start_min": null,
      "day_start_hour": null,
      "day_end_min": null,
      "day_end_hour": null,
      "days_of_week": [
        "SUNDAY",
        "MONDAY",
        "TUESDAY",
        "WEDNESDAY",
        "THURSDAY",
        "FRIDAY",
        "SATURDAY"
      ],
      "effective_from": 1701539760000,
      "effective_till": null,
      "values": {
         "auto": 10000,
        "ratio": 1.72,
        "manual": 4500,
        "threshold": 6600
      },
      "creation_info": {
        "actor": {
          "name": null,
          "email_id": "test@xyz.com"
        },
        "time": 1701243747813
      },
      "approval_info": null
    },
    {
      "id": 119,
      "name": "test3",
      "geo_region_id": 3,
      "vehicle_id": 2,
      "zone_ids": [
        400,402,403
      ],
      "cluster_ids": null,
      "type": "Filter",
      "sub_type": "MapsDistance",
      "priority": 6,
      "pending_priority": 6,
      "status": "Pending",
      "day_start_min": null,
      "day_start_hour": null,
      "day_end_min": null,
      "day_end_hour": null,
      "days_of_week": [
        "SUNDAY",
        "MONDAY",
        "TUESDAY",
        "WEDNESDAY",
        "THURSDAY",
        "FRIDAY",
        "SATURDAY"
      ],
      "effective_from": 1701539760000,
      "effective_till": null,
      "values": {
        "auto": 10000,
        "ratio": 1.72,
        "manual": 4500,
        "threshold": 6600
      },
      "creation_info": {
        "actor": {
          "name": null,
          "email_id": "test@xyz.com"
        },
        "time": 1701246745365
      },
      "approval_info": null
    },
    {
      "id": 124,
      "name": "test",
      "geo_region_id": 3,
      "vehicle_id": 2,
      "zone_ids": [
        400,401,398,402,403
      ],
      "cluster_ids": null,
      "type": "Filter",
      "sub_type": "AllocationRadius",
      "priority": 7,
      "pending_priority": 7,
      "status": "Active",
      "day_start_min": null,
      "day_start_hour": null,
      "day_end_min": null,
      "day_end_hour": null,
      "days_of_week": [
        "SUNDAY",
        "MONDAY",
        "TUESDAY",
        "WEDNESDAY",
        "THURSDAY",
        "FRIDAY",
        "SATURDAY"
      ],
      "effective_from": 1701350580000,
      "effective_till": null,
      "values": {
        "auto": 10000,
        "ratio": 1.72,
        "manual": 4500,
        "threshold": 6600
      },
      "creation_info": {
        "actor": {
          "name": null,
          "email_id": "test@xyz.com"
        },
        "time": 1701264213400
      },
      "approval_info": null
    },
    {
      "id": 125,
      "name": "fdsfd",
      "geo_region_id": 3,
      "vehicle_id": 2,
      "zone_ids": [
        403
      ],
      "cluster_ids": [
        317,306,368,297,303
      ],
      "type": "Filter",
      "sub_type": "AllocationRadius",
      "priority": 8,
      "pending_priority": 8,
      "status": "Pending",
      "day_start_min": 20,
      "day_start_hour": 20,
      "day_end_min": 30,
      "day_end_hour": 6,
      "days_of_week": [
        "SUNDAY",
        "MONDAY",
        "TUESDAY",
        "WEDNESDAY"
      ],
      "effective_from": 1703242828000,
      "effective_till": null,
      "values": {
        "auto": 10000,
        "ratio": 1.72,
        "manual": 4500,
        "threshold": 6600
      },
      "creation_info": {
        "actor": {
          "name": null,
          "email_id": "test@xyz.com"
        },
        "time": 1701427704923
      },
      "approval_info": null
    },
    {
      "id": 126,
      "name": "dasdsa",
      "geo_region_id": 3,
      "vehicle_id": 2,
      "zone_ids": [
        400,401,398
      ],
      "cluster_ids": null,
      "type": "Filter",
      "sub_type": "AllocationRadius",
      "priority": 9,
      "pending_priority": 9,
      "status": "Scheduled",
      "day_start_min": 50,
      "day_start_hour": 22,
      "day_end_min": 40,
      "day_end_hour": 16,
      "days_of_week": [
        "SUNDAY",
        "TUESDAY",
        "THURSDAY",
        "SATURDAY"
      ],
      "effective_from": 1701514129000,
      "effective_till": null,
      "values": {
        "auto": 10000,
        "ratio": 1.72,
        "manual": 4500,
        "threshold": 6600
      },
      "creation_info": {
        "actor": {
          "name": null,
          "email_id": "test@xyz.com"
        },
        "time": 1701427912640
      },
      "approval_info": null
    }
  ],
  "total_count": 9
};

var updateSuccessfulResponse = {
        "title":"Success",
        "message":"update successful"
};

function fetchAllocationCampaigns(payload, _country) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* Success */0,
                              _0: filterAllocationCampaingsDummyUsecase1
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(AllocationDashboardRepoConfig.FilterAllocationCampaignResponseConverter.execute, result);
                        });
            });
}

function getUserAccessLevel(payload, _country) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* Success */0,
                              _0: userTypeDummyAdminAccessUsecase1
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(AllocationDashboardRepoConfig.UserTypeResponseConverter.execute, result);
                        });
            });
}

function createMandatoryCampaign(payload, _country) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* Success */0,
                              _0: updateSuccessfulResponse
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(AllocationDashboardRepoConfig.CreateMandatoryCampaignResponseConverter.execute, result);
                        });
            });
}

function updateMandatoryCampaign(payload, _country) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* Success */0,
                              _0: updateStatusSuccessfulResponse
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(AllocationDashboardRepoConfig.UpdateCampaignStatusResponseConverter.execute, result);
                        });
            });
}

function createZonalOrClusterCampaign(payload) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* Success */0,
                              _0: updateSuccessfulResponse
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(AllocationDashboardRepoConfig.CreateZonalOrClusterCampaignResponseConverter.execute, result);
                        });
            });
}

function fetchZoneClusterCampaigns(payload, country) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* Success */0,
                              _0: zoneClusterPayloadUsecase1
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(AllocationDashboardRepoConfig.ZoneClusterCampaignResponseConverter.execute, result);
                        });
            });
}

function updateZoneClusterCampaigns(payload, country) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* Success */0,
                              _0: updateSuccessfulResponse
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(AllocationDashboardRepoConfig.UpdateZoneClusterCampaignsResponseConverter.execute, result);
                        });
            });
}

var AllocationDashboardRepo = {
  fetchAllocationCampaigns: fetchAllocationCampaigns,
  getUserAccessLevel: getUserAccessLevel,
  createMandatoryCampaign: createMandatoryCampaign,
  updateMandatoryCampaign: updateMandatoryCampaign,
  createZonalOrClusterCampaign: createZonalOrClusterCampaign,
  fetchZoneClusterCampaigns: fetchZoneClusterCampaigns,
  updateZoneClusterCampaigns: updateZoneClusterCampaigns
};

export {
  AllocationDashboardRepo ,
  
}
/* AllocationDashboardRepoConfig Not a pure module */
